import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';

export interface CheckingGateSpinnerProps {
  message: string;
  /** `fullscreen` — before `DashboardLayout` mounts. `embedded` — main column only (sidebar already visible). */
  layout?: 'fullscreen' | 'embedded';
}

/**
 * Spinner + label for auth and permission gates (replaces skeleton placeholders for these steps).
 */
export const CheckingGateSpinner: React.FC<CheckingGateSpinnerProps> = ({
  message,
  layout = 'fullscreen',
}) => (
  <Box
    role="status"
    aria-busy
    aria-label={message}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      bgcolor: SEARCE_COLORS.background,
      width: '100%',
      ...(layout === 'fullscreen'
        ? { minHeight: '100vh' }
        : { minHeight: 'calc(100vh - 140px)', py: 4 }),
    }}
  >
    <CircularProgress size={32} thickness={4} sx={{ color: SEARCE_COLORS.primary }} />
    <Typography variant="body2" sx={{ color: SEARCE_COLORS.textSecondary, fontWeight: 500 }}>
      {message}
    </Typography>
  </Box>
);
